import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SuspendSplitService from "services/lms/suspend/suspendSplitService";
import ReversalSuspendService from "services/lms/suspend/reversalSuspendService";
import { notification } from "antd";

export const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
  suspendSplitList: [],
  getCount: 0,
  approvalSuspendSplitList: [],
  getApprovalCount: 0,
};

export const fetchGetSuspendSplit = createAsyncThunk(
  "suspendSplit/fetchGetSuspendSplit",
  async (data) => {
    try {
      const response = await SuspendSplitService.getSuspendSplit(data);
      return response.data;
    } catch (error) {
      console.error("Error fetching suspend split:", error);
      throw error;
    }
  },
);

export const fetchGetApprovalSuspendSplit = createAsyncThunk(
  "suspendSplit/fetchGetApprovalSuspendSplit",
  async (data) => {
    try {
      const response = await SuspendSplitService.getApprovalSuspendSplit(data);
      return response.data;
    } catch (error) {
      console.error("Error fetching approval suspend split:", error);
      throw error;
    }
  },
);

export const postSuspendSplit = createAsyncThunk(
  "suspendSplit/postSuspendSplit",
  async (data) => {
    try {
      const response = await SuspendSplitService.postSuspendSplit(data);
      if (response.status === 200) {
        notification.success({
          message: "Success",
          description: "Suspend berhasil displit",
        });
        return response.data;
      } else {
        notification.error({
          message: "Error",
          description: "Gagal split suspend",
        });
      }
    } catch (error) {
      console.error("Error splitting suspend:", error);
      notification.error({
        message: "Error",
        description: error?.response?.data?.message ?? "Gagal split suspend",
      });
      throw error;
    }
  },
);

export const approveSuspendSplit = createAsyncThunk(
  "suspendSplit/approveSuspendSplit",
  async (items, { rejectWithValue }) => {
    try {
      for (const item of items) {
        await ReversalSuspendService.ApproveSuspendSplit({
          id: item.id,
          data: { userId: item.userId },
        });
      }
      notification.success({
        message: "Success",
        description: "Approval berhasil diproses",
      });
    } catch (error) {
      console.error("Error approving suspend split:", error);
      notification.error({
        message: "Error",
        description: error?.response?.data?.message ?? "Gagal memproses approval",
      });
      return rejectWithValue(error?.message);
    }
  },
);

const suspendSplitSlice = createSlice({
  name: "suspendSplit",
  initialState,
  reducers: {
    resetSuspendSplitState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.error = null;
      state.suspendSplitList = [];
      state.getCount = 0;
      state.approvalSuspendSplitList = [];
      state.getApprovalCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetSuspendSplit.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchGetSuspendSplit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.suspendSplitList = action.payload;
        state.getCount = action.payload?.count || 0;
      })
      .addCase(fetchGetSuspendSplit.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      .addCase(fetchGetApprovalSuspendSplit.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchGetApprovalSuspendSplit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.approvalSuspendSplitList = action.payload;
        state.getApprovalCount = action.payload?.count || 0;
      })
      .addCase(fetchGetApprovalSuspendSplit.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      .addCase(postSuspendSplit.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(postSuspendSplit.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(postSuspendSplit.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error = action.error.message;
      })
      .addCase(approveSuspendSplit.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(approveSuspendSplit.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(approveSuspendSplit.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error = action.payload ?? action.error.message;
      });
  },
});

export const { resetSuspendSplitState } = suspendSplitSlice.actions;
export default suspendSplitSlice.reducer;
